import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EvaluationAthleteProvider } from '../../evaluation-athlete/providers/evaluation-athlete-provider.services';
import { ArrayUtils } from '../../common/providers/array-utils';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';
import { ConfigProvider } from "../../config-provider.service";
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { Organization } from "../../common/models/organization";
import { User } from "../../common/models/user";
import { EvaluationAthlete } from "../../common/models/evaluation-athlete";
import { Question } from "../../common/models/question";
import { AppDatePipe } from "../../common/pipes/app-date";
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { Error401Component } from "../../common/components/error-401/error-401";
import { Error404Component } from "../../common/components/error-404/error-404";
import { NgClass, NgIf } from "@angular/common";
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { MatCardModule } from "@angular/material/card";
import { MobileModuleContentComponent } from "../../common/components/mobile-module-content/mobile-module-content";
import { MatChipsModule } from "@angular/material/chips";
import { EvaluationAthleteResultComponent } from "../../evaluation-athlete/components/result/evaluation-athlete-result";
import { MainActionComponent } from "../../common/components/main-action/main-action";

@Component({
  selector: 'app-mobile-evaluation-show',
  templateUrl: './mobile.evaluation.show.component.html',
  styleUrls: ['./mobile.evaluation.show.component.scss'],
  imports: [
    MobileHeaderComponent,
    MobileSideMenuComponent,
    Error401Component,
    Error404Component,
    NgIf,
    MobilePageContentComponent,
    MatCardModule,
    MobileModuleContentComponent,
    MatChipsModule,
    NgClass,
    TranslateModule,
    AppDatePipe,
    EvaluationAthleteResultComponent,
    MainActionComponent
  ],
  standalone: true
})
export class MobileEvaluationShowComponent implements OnInit, OnDestroy {

    public pageTitle = 'EvaluationAthleteList';
    public isLoading = true;
    public is401 = false;
    public is404 = false;
    public isDesktop = false;

    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;
    public evaluationAthlete: EvaluationAthlete = {} as EvaluationAthlete;
    public questions: Question[] = [];

    public evaluationsAthletes: EvaluationAthlete[] = [];
    public evaluationsAthletesGrouped: EvaluationAthlete[] = [];
    public isSubmitting = false;

    public evaluationAthleteNotes: FormControl = new FormControl('');

    @ViewChild(MatPaginator, {static: false}) public paginator: MatPaginator | undefined;

    private subscriptions: Subscription[] = [];

    constructor(
        public conf: ConfigProvider,
        private title: Title,
        private datePipe: AppDatePipe,
        private translater: TranslateService,
        private route: ActivatedRoute,
        private evaluationAthleteProvider: EvaluationAthleteProvider,
        private arrayUtils: ArrayUtils,
    ) {
    }

    public ngOnInit() {
        // Load athlete and annual plan if it exists
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { //{ organization: Organization; athlete: Athlete; evaluationAthlete: EvaluationAthlete }
                if (data.organization) {
                    this.organization = data.organization;
                }

                if (data.athlete) {
                    this.athleteUser = data.athlete;
                }

                if (data.evaluationAthlete) {
                    this.evaluationAthlete = data.evaluationAthlete;
                    this.evaluationAthleteNotes.setValue(this.evaluationAthlete.notes);
                }

                this.loadData();
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public loadData() {
        // TODO: check rights
        if (this.evaluationAthlete && false) {
            this.is401 = true;
            return;
        }

        const evaluations$ = this.evaluationAthleteProvider.getAll(this.organization, this.athleteUser.athlete!).subscribe({
            next: (evaluationsAthletes) => {
                this.evaluationsAthletes = evaluationsAthletes;
                this.evaluationsAthletesGrouped = this.arrayUtils.groupByAttribute(this.evaluationsAthletes, 'evaluation', 'type');
                this.createPageTitle();
                this.isLoading = false;
            },
        });
    }

    private createPageTitle() {
        this.pageTitle = this.translater.instant('EvaluationOf', { date: this.datePipe.transform(this.evaluationAthlete.date, 'mediumDate') });
        this.title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
    }
}
